import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core";
import { FormattedMessage } from "react-intl";
import Grid from "@material-ui/core/Grid";
import ICIPAdminService from "../../../../../services/ICIPAdminService";
import { NewRaffleDraw } from "../modals/NewRaffleDraw";
import { Box, TableRow } from "@material-ui/core";

import TableData, {
  StyledTableCell,
  StyledTableRow,
} from "../../../components/TableData";
import RaffleDraw from "../../../../../models/RaffleDraw";
import Button from "@material-ui/core/Button";
import { EditRaffleDraw } from "../modals/EditRaffleDraw";
import moment from "moment";
import { EditWinningPackages } from "../modals/EditWinningPackages";
import WinningPackage from "../../../../../models/WinningPackage";
import raffleDraw from "../../../../../models/RaffleDraw";
import NewWinningPackage from "../modals/NewWinningPackage";

interface WinningPackagesListProps {}

const useStyles = makeStyles(() => ({
  tabHeading: {
    fontWeight: "bold",
    fontSize: 14,
  },
  newButton: {
    //textTransform: "none",
    fontSize: 13,
  },
  subButton: {
    textTransform: "none",
    fontSize: 10,
    padding: 2,
    margin: 2,
    width: 35,
  },
  packagePadding: {
    padding: 50,
  },
}));

export const WinningPackagesList = (props: WinningPackagesListProps) => {
  //const intl = useIntl();
  const classes = useStyles();

  // State
  const [winningPackages, setWinningPackages] = useState([]);
  const [error, setError] = useState(false);
  const [winningPackagesModalOpened, setWinningPackagesModalOpened] = useState(false);
  const [editWinningPackagesModalOpened, setEditWinningPackagesModalOpened] = useState(false);
  const [selectedWinningPackage, setSelectedWinningPackage] = useState(null);

  const toggleWinningPackageModal = () => {
    setWinningPackagesModalOpened(!winningPackagesModalOpened);
  };

  const toggleEditWinningPackageModal = () => {
    setEditWinningPackagesModalOpened(!editWinningPackagesModalOpened);
  };

  const handleEditClick = (e, data) => {
    setSelectedWinningPackage(data);
    toggleEditWinningPackageModal();
  };

  const fetchWinningPackagesList = () => {
    ICIPAdminService.getWinningPackages().then((response) => {
      if (response.isSuccess) {
        switch (response.data.code) {
          case 100:
            const winningPackages = JSON.parse(
              JSON.stringify(response.data.data)
            );
            setWinningPackages(winningPackages);
            break;
          case 110:
            setError(true);
        }
      } else {
        setError(true);
      }
      //setLoading(false);
    });
  };

  useEffect(() => {
    fetchWinningPackagesList();
  }, []);

  // Renders

  const render = () => {
    return (
      <>
        {winningPackagesModalOpened && (
          <NewWinningPackage
            closeCallback={toggleWinningPackageModal}
            onSubmitCallback={fetchWinningPackagesList}
            isOpened={winningPackagesModalOpened}
          />
        )}
        {editWinningPackagesModalOpened && (
          <EditWinningPackages
            closeCallback={toggleEditWinningPackageModal}
            onSubmitCallback={fetchWinningPackagesList}
            isOpened={editWinningPackagesModalOpened}
            winningPackage={selectedWinningPackage}
          />
        )}
        <Box component="div">
          <Grid container alignItems="flex-start" item xs={6} lg={6}>
            <Button
              color="secondary"
              variant="contained"
              className={classes.newButton}
              onClick={toggleWinningPackageModal}
            >
              <FormattedMessage id="sharedScreen.newWinningPackage" />
            </Button>
          </Grid>
          <TableData
            rows={renderWinningPackagesTableRows()}
            header={renderWinningPackagesTableHeader()}
          />
        </Box>
      </>
    );
  };

  const renderWinningPackagesTableRows = () => {
    return winningPackages.map((row, index) => {
      let winningPackage = row as WinningPackage;
      return (
        <StyledTableRow key={index}>
          <StyledTableCell component="td" scope="row">
            {winningPackage.priority}
          </StyledTableCell>
          <StyledTableCell component="td" scope="row">
            {winningPackage.designation_fr}
          </StyledTableCell>
          <StyledTableCell component="td" scope="row">
            {winningPackage.designation_en}
          </StyledTableCell>
          <StyledTableCell component="td" scope="row">
            {winningPackage.code}
          </StyledTableCell>
          <StyledTableCell component="td" scope="row">
            {winningPackage.wallet_type_name}
          </StyledTableCell>
          <StyledTableCell component="td" scope="row">
            {winningPackage.amount}
          </StyledTableCell>
          <StyledTableCell component="td" scope="row">
            {winningPackage.currency_code}
          </StyledTableCell>
          <StyledTableCell component="td" scope="row">
            {winningPackage.is_qatar === 1 ? (
              ""
            ) : (
              <Button
                color="secondary"
                variant="contained"
                className={classes.subButton}
                value={winningPackage.id}
                onClick={(e) => handleEditClick(e, winningPackage)}
              >
                Edit
              </Button>
            )}
          </StyledTableCell>
        </StyledTableRow>
      );
    });
  };

  const renderWinningPackagesTableHeader = () => {
    return (
      <TableRow>
        <StyledTableCell className={classes.tabHeading}>
          <FormattedMessage id="sharedScreen.winningPackagePriority" />
        </StyledTableCell>
        <StyledTableCell align="left" className={classes.tabHeading}>
          <FormattedMessage id="sharedScreen.winningPackageDesignationFr" />
        </StyledTableCell>
        <StyledTableCell align="left" className={classes.tabHeading}>
          <FormattedMessage id="sharedScreen.winningPackageDesignationEn" />
        </StyledTableCell>
        <StyledTableCell align="left" className={classes.tabHeading}>
          <FormattedMessage id="sharedScreen.winningPackageCode" />
        </StyledTableCell>
        <StyledTableCell align="left" className={classes.tabHeading}>
          <FormattedMessage id="sharedScreen.winningPackageWalletType" />
        </StyledTableCell>
        <StyledTableCell align="left" className={classes.tabHeading}>
          <FormattedMessage id="sharedScreen.winningPackageWalletAmount" />
        </StyledTableCell>
        <StyledTableCell align="left" className={classes.tabHeading}>
          <FormattedMessage id="sharedScreen.winningPackageWalletCurrencyId" />
        </StyledTableCell>
        <StyledTableCell align="left" className={classes.tabHeading}>
          <FormattedMessage id="sharedScreen.actions" />
        </StyledTableCell>
      </TableRow>
    );
  };

  return (
    <Grid className={classes.packagePadding}>
      <Box component="div">
        <Box component="div">
          <Box component="div">
            <Box component="div">{render()}</Box>
          </Box>
        </Box>
      </Box>
    </Grid>
  );
};
